module.exports = __webpack_public_path__ + "img/cloud_1_act.99d6a07e.svg";